export const isInstagram = navigator.userAgent.toLowerCase().trim().includes('instagram');
